import React from 'react';
import { Box, TextField, IconButton } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { styled } from '@mui/material/styles';
import CustomerSelectionTable from './CustomerSelectionTable';

// Styled IconButton - Puantajlar.js'deki ile aynı stil
const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.5),
  marginLeft: theme.spacing(1),
  width: '30px',
  height: '30px',
}));

const EditPuantajModal = ({
  open,
  formData,
  onChange,
  formRefs,
  isCustomerSelectionOpen,
  toggleCustomerSelection,
  allCustomers,
  handleSelectCustomer,
  onClose,
  onSubmit,
  // Yeni prop'lar
  machineOptions,
  operatorOptions,
  isMachineSelectionOpen,
  toggleMachineSelection,
  handleSelectMachine,
  isOperatorSelectionOpen,
  toggleOperatorSelection,
  handleSelectOperator
}) => {
  if (!open) return null;

  // Debug log'ları
  console.log('🔄 EditPuantajModal render ediliyor:', {
    'Modal açık': open,
    'FormData Müşteri': formData['Müşteri Adı'],
    'FormData obje': formData,
    'Dropdown açık': isCustomerSelectionOpen
  });

  return (
    <div className="edit-modal" onClick={onClose}>
      <div className="edit-puantaj-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Puantaj Düzenle</h3>
        </div>
        <div className="edit-form">
          <Box display="flex" alignItems="center">
            <TextField
              label="Müşteri Adı"
              fullWidth
              margin="normal"
              value={(() => {
                const customerValue = formData['Müşteri Adı'] || '';
                console.log('📝 TextField render - Müşteri adı değeri:', customerValue);
                return customerValue;
              })()}
              InputProps={{
                readOnly: true,
                style: { cursor: 'pointer' }
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                console.log('🖱️ Müşteri TextField tıklandı');
                toggleCustomerSelection();
              }}
              inputRef={formRefs['Müşteri Adı']}
              inputProps={{ autoComplete: 'off' }}
            />
            <StyledIconButton
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                toggleCustomerSelection();
              }}
              size="small"
              type="button"
            >
              <ArrowDropDownIcon fontSize="small" />
            </StyledIconButton>
          </Box>
          {isCustomerSelectionOpen && (
            <CustomerSelectionTable
              customers={allCustomers}
              onSelectCustomer={handleSelectCustomer}
              enableAutoUppercase={true}
            />
          )}
          <Box display="flex" alignItems="center">
            <TextField
              label="Makine İsmi"
              fullWidth
              margin="normal"
              value={formData['Makine İsmi'] || ''}
              InputProps={{
                readOnly: true,
                style: { cursor: 'pointer' }
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                toggleMachineSelection();
              }}
              inputRef={formRefs['Makine İsmi']}
              inputProps={{ autoComplete: 'off' }}
            />
            <StyledIconButton
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                toggleMachineSelection();
              }}
              size="small"
              type="button"
            >
              <ArrowDropDownIcon fontSize="small" />
            </StyledIconButton>
          </Box>
          {isMachineSelectionOpen && (
            <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ccc', borderRadius: '4px', marginTop: '8px' }}>
              {machineOptions.map((machine, index) => (
                <div
                  key={index}
                  style={{
                    padding: '8px 12px',
                    cursor: 'pointer',
                    borderBottom: index < machineOptions.length - 1 ? '1px solid #eee' : 'none'
                  }}
                  onClick={() => handleSelectMachine(machine)}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  {machine.label}
                </div>
              ))}
            </div>
          )}
          <Box display="flex" alignItems="center">
            <TextField
              label="Operatör Adı"
              fullWidth
              margin="normal"
              value={formData['Operatör Adı'] || ''}
              InputProps={{
                readOnly: true,
                style: { cursor: 'pointer' }
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                toggleOperatorSelection();
              }}
              inputRef={formRefs['Operatör Adı']}
              inputProps={{ autoComplete: 'off' }}
            />
            <StyledIconButton
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                toggleOperatorSelection();
              }}
              size="small"
              type="button"
            >
              <ArrowDropDownIcon fontSize="small" />
            </StyledIconButton>
          </Box>
          {isOperatorSelectionOpen && (
            <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ccc', borderRadius: '4px', marginTop: '8px' }}>
              {operatorOptions.map((operator, index) => (
                <div
                  key={index}
                  style={{
                    padding: '8px 12px',
                    cursor: 'pointer',
                    borderBottom: index < operatorOptions.length - 1 ? '1px solid #eee' : 'none'
                  }}
                  onClick={() => handleSelectOperator(operator)}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  {operator.label}
                </div>
              ))}
            </div>
          )}
          <TextField
            label="Tarih"
            type="date"
            fullWidth
            margin="normal"
            value={formData['Tarih'] || ''}
            onChange={(e) => {
              const newValue = e.target.value;
              onChange(prev => ({
                ...prev,
                'Tarih': newValue
              }));
            }}
            inputRef={formRefs['Tarih']}
            inputProps={{ autoComplete: 'off' }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <div className="time-inputs">
            <TextField
              label="1. Başlangıç Saati"
              value={formData['1. Başlangıç Saati'] || ''}
              onChange={(e) => {
                let value = e.target.value.replace(/[^0-9]/g, '');
                if (value.length >= 3) {
                  value = value.slice(0, 2) + ':' + value.slice(2, 4);
                }
                
                // Real-time saat validasyonu
                if (value.length === 5) {
                  const [hours, minutes] = value.split(':').map(Number);
                  if (hours > 23) {
                    value = '23:' + value.slice(3);
                  }
                  if (minutes > 59) {
                    value = value.slice(0, 3) + '59';
                  }
                }
                
                onChange(prev => ({
                  ...prev,
                  '1. Başlangıç Saati': value
                }));
              }}
              inputRef={formRefs['1. Başlangıç Saati']}
              inputProps={{ 
                autoComplete: 'off',
                placeholder: 'HH:MM',
                maxLength: 5,
                pattern: '[0-9]{2}:[0-9]{2}'
              }}
            />
            <TextField
              label="1. Bitiş Saati"
              value={formData['1. Bitiş Saati'] || ''}
              onChange={(e) => {
                let value = e.target.value.replace(/[^0-9]/g, '');
                if (value.length >= 3) {
                  value = value.slice(0, 2) + ':' + value.slice(2, 4);
                }
                
                // Real-time saat validasyonu
                if (value.length === 5) {
                  const [hours, minutes] = value.split(':').map(Number);
                  if (hours > 23) {
                    value = '23:' + value.slice(3);
                  }
                  if (minutes > 59) {
                    value = value.slice(0, 3) + '59';
                  }
                }
                
                onChange(prev => ({
                  ...prev,
                  '1. Bitiş Saati': value
                }));
              }}
              inputRef={formRefs['1. Bitiş Saati']}
              inputProps={{ 
                autoComplete: 'off',
                placeholder: 'HH:MM',
                maxLength: 5,
                pattern: '[0-9]{2}:[0-9]{2}'
              }}
            />
          </div>
          <div className="time-inputs">
            <TextField
              label="2. Başlangıç Saati"
              value={formData['2. Başlangıç Saati'] || ''}
              onChange={(e) => {
                let value = e.target.value.replace(/[^0-9]/g, '');
                if (value.length >= 3) {
                  value = value.slice(0, 2) + ':' + value.slice(2, 4);
                }
                
                // Real-time saat validasyonu
                if (value.length === 5) {
                  const [hours, minutes] = value.split(':').map(Number);
                  if (hours > 23) {
                    value = '23:' + value.slice(3);
                  }
                  if (minutes > 59) {
                    value = value.slice(0, 3) + '59';
                  }
                }
                
                onChange(prev => ({
                  ...prev,
                  '2. Başlangıç Saati': value
                }));
              }}
              inputRef={formRefs['2. Başlangıç Saati']}
              inputProps={{ 
                autoComplete: 'off',
                placeholder: 'HH:MM',
                maxLength: 5,
                pattern: '[0-9]{2}:[0-9]{2}'
              }}
            />
            <TextField
              label="2. Bitiş Saati"
              value={formData['2. Bitiş Saati'] || ''}
              onChange={(e) => {
                let value = e.target.value.replace(/[^0-9]/g, '');
                if (value.length >= 3) {
                  value = value.slice(0, 2) + ':' + value.slice(2, 4);
                }
                
                // Real-time saat validasyonu
                if (value.length === 5) {
                  const [hours, minutes] = value.split(':').map(Number);
                  if (hours > 23) {
                    value = '23:' + value.slice(3);
                  }
                  if (minutes > 59) {
                    value = value.slice(0, 3) + '59';
                  }
                }
                
                onChange(prev => ({
                  ...prev,
                  '2. Bitiş Saati': value
                }));
              }}
              inputRef={formRefs['2. Bitiş Saati']}
              inputProps={{ 
                autoComplete: 'off',
                placeholder: 'HH:MM',
                maxLength: 5,
                pattern: '[0-9]{2}:[0-9]{2}'
              }}
            />
          </div>
          <TextField
            label="Yetkili Adı"
            fullWidth
            margin="normal"
            value={formData['Yetkili Adı'] || ''}
            onChange={(e) => {
              const newValue = e.target.value;
              onChange(prev => ({
                ...prev,
                'Yetkili Adı': newValue
              }));
            }}
            inputRef={formRefs['Yetkili Adı']}
            inputProps={{ autoComplete: 'off' }}
          />
          <TextField
            label="Çalışma Detayı"
            fullWidth
            margin="normal"
            multiline
            rows={3}
            value={formData['Çalışma Detayı'] || ''}
            onChange={(e) => {
              const newValue = e.target.value;
              onChange(prev => ({
                ...prev,
                'Çalışma Detayı': newValue
              }));
            }}
            inputRef={formRefs['Çalışma Detayı']}
            inputProps={{ autoComplete: 'off' }}
          />
          <div className="modal-buttons">
            <button
              type="button"
              onClick={onClose}
              className="cancel-button"
            >
              İptal
            </button>
            <button
              type="button"
              onClick={onSubmit}
              className="save-button"
            >
              Onayla ve Kaydet
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPuantajModal; 